import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Camera } from "lucide-react";
import { api } from "@/lib/api";
import { FadeUp } from "@/components/Reveal";

export default function PhotoOfMonth() {
  const [potm, setPotm] = useState(null);

  useEffect(() => {
    api.get("/potm/current").then(({ data }) => setPotm(data)).catch(() => {});
  }, []);

  if (!potm) return null;

  return (
    <section data-testid="potm-home" className="relative bg-ink text-white grain overflow-hidden">
      <div className="relative z-10 max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 py-24 lg:py-32 grid lg:grid-cols-12 gap-12 items-center">
        <FadeUp className="lg:col-span-6 order-2 lg:order-1">
          <p className="label text-canary mb-6 flex items-center gap-2"><Camera size={15} /> Canary Photo of the Month</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">{potm.title}</h2>
          <p className="mt-5 label text-white/50">{potm.photographer}{potm.location ? ` · ${potm.location}` : ""} · {potm.month}</p>
          <p className="mt-6 text-lg text-white/70 leading-relaxed max-w-xl">{potm.intro}</p>
          <Link to="/photo-of-the-month" data-testid="potm-read-btn"
            className="inline-flex items-center gap-2 mt-9 label bg-canary text-ink px-8 py-4 rounded-full hover:bg-white transition-colors duration-300">
            Read the story <ArrowUpRight size={16} />
          </Link>
        </FadeUp>
        <motion.div
          initial={{ opacity: 0, scale: 1.04 }} whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6 order-1 lg:order-2 hover-img aspect-[4/3]"
        >
          <img src={potm.photo} alt={potm.title} className="h-full w-full object-cover" />
        </motion.div>
      </div>
    </section>
  );
}
